import React from 'react';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';

const WindowAlert = (props) => {
    return(
        <SweetAlert
            show={props.show}
            title={props.messageType}
            text={props.text}
            onConfirm={props.onCofirm}
            onCancel={props.onCancel}
        />
    );
}
export default WindowAlert;


// WEBPACK FOOTER //
// ./src/app/common/AlertComponent.js